import React from "react";
import { Box, Flex, useTheme } from "@chakra-ui/react";
import { InvestorPortalWhiteLabelPageContainerProps } from "./InvestorPortalWhiteLabelPageContainer.types";

export const InvestorPortalWhiteLabelPageContainer: React.FC<
  InvestorPortalWhiteLabelPageContainerProps
> = ({ children, titleRight, title, ...rest }) => {
  const theme = useTheme();

  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      w={"100%"}
      px={3}
      {...rest}
    >
      <Box w={"100%"} {...theme?.investorPortal.fixed}>
        {title && (
          <Flex className={"items-center"} mb={6}>
            <Box textStyle={"h2"} flexGrow={1}>
              {title}
            </Box>
            {titleRight}
          </Flex>
        )}
        {children}
      </Box>
    </Flex>
  );
};
